var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyProps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2554_158064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3334H5C3.15916 13.3334 1.66666 11.8409 1.66666 10V5.00002C1.66666 3.15919 3.15916 1.66669 5 1.66669H10C11.8408 1.66669 13.3333 3.15919 13.3333 5.00002V10C13.3333 11.8409 11.8408 13.3334 10 13.3334Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3334H10C8.15916 18.3334 6.66666 16.8409 6.66666 15V10C6.66666 8.15919 8.15916 6.66669 10 6.66669H15C16.8408 6.66669 18.3333 8.15919 18.3333 10V15C18.3333 16.8409 16.8408 18.3334 15 18.3334Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2554_158064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyProps);
export default __webpack_public_path__ + "static/media/copy-props.7cba5ae6491811d81967856c83e847fd.svg";
export { ForwardRef as ReactComponent };